export const COAL_MARK = {
  FAT: 'fat',
  GAS: 'gas',
  GF: 'gasFat',
};
